<template>
  <div class="text-center space-y-4">
    <h3 class="text-xl font-semibold text-success">
      🎉 {{ $t("totalForm.thanks") }}
    </h3>
    <p class="text-sm text-gray-600">{{ $t("totalForm.followup") }}</p>
  </div>
</template>
